import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { combineLatest, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import type { AppProductLine as ProductLine } from 'graphql/models/extended';
import { StoredFavoritePositions } from 'models/favorites.model';
import type { OfferBase } from 'models/offer.model';
import { FavoriteService } from 'shared/services/favorite.service';
import { StoreService } from 'shared/services/store.service';

import { AddFavoriteComponent } from '../add-favorite.component';

@Component({
  selector: 'app-add-favorite-modal',
  templateUrl: './add-favorite-modal.component.html',
  styleUrls: ['./add-favorite-modal.component.scss']
})
export class AddFavoriteModalComponent implements OnInit {
  @ViewChild(AddFavoriteComponent) addFavoriteComponent!: AddFavoriteComponent;

  offer!: OfferBase;

  currentPosition!: ProductLine;

  get form(): UntypedFormGroup {
    return this.addFavoriteComponent.form;
  }

  constructor(
    private favoriteService: FavoriteService,
    private storeService: StoreService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    combineLatest([
      this.storeService.getCurrentOffer().pipe(take(1)),
      this.storeService.getCurrentPosition().pipe(take(1))
    ])
      .subscribe(([currentOffer, currentPosition]) => {
        this.offer = currentOffer || {};
        this.currentPosition = currentPosition;
      });
  }

  onSubmit(): Observable<StoredFavoritePositions> {
    return this.favoriteService.addFavorite({
      lineId: this.currentPosition.id,
      offer: this.offer,
      productId: this.currentPosition.product.name,
      title: this.form.controls.name.value
    });
  }
}
